import React, { FC, useState, useRef } from 'react';
import { Button } from 'components/button/Button';
import { FeatureCard } from 'components/featureCard/FeatureCard';
import { home } from 'texts/texts';
import './AIUsage.css';
import { GetToastieDialog } from 'components/get-toastie-dialog/get-toastie-dialog';
import { TextWithStyle } from 'components/TextWithStyle';
import { motion, useInView } from "framer-motion"

interface NavbarProps { }

export const AIUsage: FC<NavbarProps> = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const handleGetToastieClick = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };


  return (
    <div className="ai-usage-section">
      <div className="home-content-container">
        <motion.div
            ref={ref}
            initial={{ y: 100, opacity: 0 }}
            animate={isInView ? { y: 0, opacity: 1 } : { opacity: 0, y: 100 }}
            transition={{ type: "spring", stiffness: 50 }}
            className="feature-container">
          <h2>{home.featureMessage}</h2>
          <div className='feature-row-1'>
            {home.features.map((feature, index) => (
              <React.Fragment key={index}>
                <FeatureCard
                  key={index}
                  iconSrc = {feature.iconSrc}
                  title={feature.title}
                  description={feature.description}
                />
                {index === 0 && (
                <>
                  <div className="additional-div"></div>
                  <div className="additional-div"></div>
                </>
              )}
                {index === 1 && (
                <>
                  <div className="additional-div"></div>
                  <div className="additional-div"></div>
                </>
              )}
              </React.Fragment>
            ))}
          </div>
          <div className="feature-row-2">
            <div className="horizontal-line"></div>
            <div className="vertical-line"></div>
          </div>
          <div id="cta-box-connect-container">
              <div className="additional-div"></div>
              <div className="additional-div"></div>
          </div>
          <div className="cta-box">
            {/* <img src={sparklingSrc} alt="Sparkling Icon" /> */}
            {/* <h3>{home.featureConclusion}</h3> */}
            <div className="sparkle-cluster">
              {/* <!-- Large sparkle --> */}
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
                <path d="M18 2L20.5 14.5L33 18L20.5 21.5L18 34L15.5 21.5L3 18L15.5 14.5L18 2Z" fill="#f2722e" opacity="0.9"></path>
              </svg>
              {/* <!-- Small sparkle bottom-left --> */}
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 1L11.5 8.5L19 10L11.5 11.5L10 19L8.5 11.5L1 10L8.5 8.5L10 1Z" fill="#f9a876" opacity="0.85"></path>
              </svg>
              {/* <!-- Tiny sparkle top-left --> */}
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M7 1L8 5.5L12.5 7L8 8.5L7 13L6 8.5L1.5 7L6 5.5L7 1Z" fill="#f5c842" opacity="0.9"></path>
              </svg>
            </div>
            <h3>
              {home.featureConclusion.map((part, index) => (
                <TextWithStyle key={index} text={part.text} style={part.style} />
              ))}
            </h3>
            <GetToastieDialog
              isOpen={isDialogOpen}
              onClose={handleCloseDialog}
            />
            <Button label={home.buttonText} onClick={handleGetToastieClick} />
          </div>
        </motion.div>
      </div>
    </div>
  )
};
